// extracted by mini-css-extract-plugin
export default {"cls1":"KhzTDjC2s_zAxDDuFEAd","cls2":"NfFW_1jtXimw4SlnpA9D KhzTDjC2s_zAxDDuFEAd"};